module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    staticClass: "text-gray-700 text-base",
    attrs: {
      "size": "md",
      "title": 'Edit Follow-Up Questions',
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('body', {
    staticClass: "mx-7 flex flex-col overflow-x-hidden h-full my-5"
  }, [_c('div', {
    staticClass: "flex justify-between items-center space-x-2",
    class: [{
      'pb-3': _vm.questions.length > 0
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.question_to_add),
      expression: "question_to_add"
    }],
    staticClass: "bg-white focus-within:border-gray-400 w-full py-2 px-4 rounded border border-solid border-gray-200",
    attrs: {
      "placeholder": "Enter a Question"
    },
    domProps: {
      "value": (_vm.question_to_add)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleAddQuestion.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.question_to_add = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "bg-blueGray-700 text-white py-2 px-4 rounded disabled:opacity-50",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.handleAddQuestion
    }
  }, [_vm._v("\n        Add\n      ")])]), _vm._v(" "), _c('Draggable', {
    staticClass: "h-full flex-grow overflow-y-auto",
    on: {
      "start": function($event) {
        _vm.drag_content_resource = true
      },
      "end": function($event) {
        _vm.drag_content_resource = false
      }
    },
    model: {
      value: (_vm.questions),
      callback: function($$v) {
        _vm.questions = $$v
      },
      expression: "questions"
    }
  }, _vm._l((_vm.questions), function(question, index) {
    return _c('div', {
      key: index
    }, [_c('FollowUpQuestion', {
      staticClass: "mb-3",
      attrs: {
        "question": question
      },
      on: {
        "handleDeleteQuestion": _vm.handleDeleteQuestion,
        "handleSaveInformation": _vm.handleSaveInformation
      }
    })], 1)
  }), 0)], 1), _vm._v(" "), _c('footer', {
    staticClass: "mx-7 mb-5"
  }, [_c('div', {
    staticClass: "flex justify-between w-full text-sm"
  }, [_c('button', {
    staticClass: "px-4 py-2 mr-2 bg-white border border-solid border-gray-200 hover:shadow-sm rounded cursor-pointer text-gray-600",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n        Cancel\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "sample px-5 py-2 bg-primary rounded cursor-pointer text-white font-medium disabled:opacity-50",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.saveFollowUpQuestions
    }
  }, [_vm._v("\n        Save Changes\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-018336ac!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/editFollowUpQuestionsModal/editFollowUpQuestions.vue
// module id = 1278
// module chunks = 61